import { DisabledEvaluator } from '@/types/filter';

const shouldDisableTerritoryFilter: DisabledEvaluator = ({ contexts: { userInfo, isSecondaryLevelFilter } }) => {
  const countriesToLock = ['DE'];
  const isDEUser = userInfo.countries.some(group => countriesToLock.includes(group));
  return isDEUser && isSecondaryLevelFilter === true;
};

export default shouldDisableTerritoryFilter;
